import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type GetLocalFolderPathMutationVariables = Types.Exact<{ [key: string]: never; }>;


export type GetLocalFolderPathMutation = { __typename?: 'Mutation', getLocalFolderPath: string };


export const GetLocalFolderPath = /*#__PURE__*/ gql`
    mutation GetLocalFolderPath {
  getLocalFolderPath
}
    ` as unknown as DocumentNode<GetLocalFolderPathMutation, GetLocalFolderPathMutationVariables>;

          

          export const useGetLocalFolderPathMutation = (options?:MutationHookOptions<GetLocalFolderPathMutation, GetLocalFolderPathMutationVariables>) => useMutation(GetLocalFolderPath, options);
          

          export type GetLocalFolderPathMutationOptions = MutationHookOptions<GetLocalFolderPathMutation, GetLocalFolderPathMutationVariables>;

          

          export type GetLocalFolderPathMutationResult = ReturnType<typeof useGetLocalFolderPathMutation>[1];

          
